import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=29849ab8"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports